module.exports = __webpack_public_path__ + "images/help/icon-twr34-6fd7cecede8abf06a309183d088083fc.png";